import { render, staticRenderFns } from "./NewCallSkeleton.vue?vue&type=template&id=560f5e5c&scoped=true"
import script from "./NewCallSkeleton.vue?vue&type=script&lang=js"
export * from "./NewCallSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560f5e5c",
  null
  
)

export default component.exports